import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const AddUserModalValidationSchema = () => {
  const { t } = useTranslation()

  return yup.object({
    email: yup.string().email(t('usersPage.addNewUser.emailLabel')).required(t('emailErrors.emailRequired')),
  })
}
